module.exports = __webpack_public_path__ + "portrait1.jpg?e68a9832f1950944eb7da5e144361ad4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait1.jpg
// module id = 218
// module chunks = 0